"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M5.749 8.823C5.959 8.998 5.945 9.31 5.721 9.467L2 12.083V6.666C2 6.381 2.084 6.116 2.221 5.883L5.749 8.823ZM7.607 8.141L3.839 5H16.161L12.393 8.141L12.01 8.46L10.295 9.888C10.127 10.03 9.873 10.03 9.704 9.888L7.991 8.46L7.607 8.141ZM12.779 10.495L17.821 14.04C17.539 14.605 16.933 14.999 16.223 14.999H3.777C3.067 14.999 2.462 14.605 2.179 14.04L7.221 10.495C7.391 10.376 7.625 10.385 7.783 10.517L9.705 12.119C9.873 12.259 10.127 12.259 10.295 12.119L12.217 10.517C12.375 10.385 12.61 10.376 12.779 10.495ZM17.779 5.883C17.916 6.116 18 6.381 18 6.666V12.083L14.279 9.468C14.055 9.309 14.041 8.998 14.251 8.823L17.779 5.883Z",
    fill: "#727B7F"
  }));
};